import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  contractSelect,
  getContractDepthRequested,
  getCurrentSessionsRequested,
  removeCurrentContracts,
} from "../../../redux/actions/sessions";
import {
  convertNumberToFrontend,
  convertAmountToFrontend,
} from "../../../helpers/convert";
import moment from "moment";
import { API_DELETE, API_GET, API_PUT, API_POST } from "../../../helpers/api";
import Modal from "../../../components/Modal";
import TitleValue from "../../../components/TitleValue";
import ToggleSwitch from "../../../components/ToggleSwitch";
import Pill from "../../../components/Pill";
import Button from "../../../components/Button";
import DataTable from "../../../components/DataTable";
import DataTableBasic from "../../../components/DataTable/DataTableBasic";
import ComboBox from "../../../components/ComboBox";
import OfferTab from "../../../components/OfferTab";
import { setNotification } from "../../../helpers/notification";
import { Input, Select, Textarea } from "../../../components/Inputs";
import EmptyState from "../../../components/EmptyState/EmptyState";
import { getActiveOffersRequested } from "../../../redux/actions/offers";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";
import Icon from "../../../components/Icon";
import ModalEditSellOffer from "../../../components/Modal/ModalEditSellOffer";
import ModalContractHistory from "../../../components/Modal/ModalContractHistory";
import LabelValue from "../../../components/LabelValue";
import DataTableDraggable from "../../../components/DataTable/DataTableDraggable";
import PriceInput from "../../../components/Inputs/PriceInput";
import Loading from "../../../components/Loading";

export default function OfferOperations({ t, history }) {
  const dispatch = useDispatch();
  const selectedOrganization = useSelector(
    (state) => state.organizations.selectedOrganization
  );
  const { currentContracts, loading } = useSelector((state) => state.sessions);

  const selectedContract = useSelector(
    (state) => state.sessions.selectedContract
  );
  const contractDepthBuyList = useSelector(
    (state) => state.sessions.contractDepthBUYList
  );
  const contractDepthSellList = useSelector(
    (state) => state.sessions.contractDepthSELLList
  );
  const contractDepthBuyListSmall = useSelector(
    (state) => state.sessions.contractDepthBUYListSmall
  );
  const contractDepthSellListSmall = useSelector(
    (state) => state.sessions.contractDepthSELLListSmall
  );
  let timer1 = null;
  const [intervalState, setIntervalState] = useState(null);

  const activeOffers = useSelector((state) => state.offers.activeOffers);

  const [modalContractProcess, setModalContractProcess] = useState(false);
  const [modalEditBuyOffer, setModalEditBuyOffer] = useState(false);
  const [modalEditSellOffer, setModalEditSellOffer] = useState(false);
  const [activeContractProcess, setActiveContractProcess] = useState();
  const [
    contractProcessChangeDescription,
    setContractProcessChangeDescription,
  ] = useState("");
  const [editedOffer, setEditedOffer] = useState();
  const [editedOfferClone, setEditedOfferClone] = useState();
  const [editBuyOfferConfirmation, setEditBuyOfferConfirmation] =
    useState(false);
  const [editBuyOfferLoading, setEditBuyOfferLoading] = useState(false);
  const [deletedOffer, setDeletedOffer] = useState();
  const [deletedBuyOffer, setDeletedBuyOffer] = useState(false);
  const [deletedSellOffer, setDeletedSellOffer] = useState(false);
  const [deletedOfferLoading, setDeletedOfferLoading] = useState(false);
  const [
    contractProcessChangeApproveModal,
    setContractProcessChangeApproveModal,
  ] = useState(false);
  const [contractProcessChangeLoading, setContractProcessChangeLoading] =
    useState(false);
  const [contractDepthModal, setContractDepthModal] = useState(false);
  const [inspectedContract, setInspectedContract] = useState();
  const [selectedContractStatus, setSelectedContractStatus] =
    useState("ACTIVE");
  const [organizationBuyLimit, setOrganizationBuyLimit] = useState(0);
  const [editedOrganizationBuyLimit, setEditedOrganizationBuyLimit] =
    useState(0);

  const offerStatusHandling = {
    CANCELLED: {
      color: "important",
      text: t("pages.default.offerOperations.status.cancelled"),
      showEdit: false,
      showDelete: false,
    },
    OPEN: {
      color: "success",
      text: t("pages.default.offerOperations.status.open"),
      showEdit: true,
      showDelete: true,
    },
    SOLD: {
      color: "primary",
      text: t("pages.default.offerOperations.status.sold"),
      showEdit: false,
      showDelete: false,
    },
    DELETED: {
      color: "default",
      text: t("pages.default.offerOperations.status.deleted"),
      showEdit: false,
      showDelete: false,
    },
    CLOSED: {
      color: "new",
      text: t("pages.default.offerOperations.status.closed"),
      showEdit: false,
      showDelete: false,
    },
    DRAFT: {
      color: "attention",
      text: t("pages.default.offerOperations.status.draft"),
      showEdit: true,
      showDelete: true,
    },
  };
  const contractsColumns = [
    {
      key: "contractName",
      name: t("pages.default.offerOperations.table.contractName"),
      selector: "contractName",
      sortable: true,
    },
    {
      key: "bestBuyAmount",
      name: t("pages.default.offerOperations.table.bestBuyAmount"),
      selector: "bestBuyAmount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.bestBuyAmount);
      },
    },
    {
      key: "bestSpread",
      name: t("pages.default.offerOperations.table.bestSpread"),
      selector: "bestSpread",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.bestSpread, digit: 2 });
      },
    },
    {
      key: "bestSellAmount",
      name: t("pages.default.offerOperations.table.bestSellAmount"),
      selector: "bestSellAmount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.bestSellAmount);
      },
    },
    {
      key: "maxMatchPrice",
      name: t("pages.default.offerOperations.table.maxMatchPrice"),
      selector: "maxMatchPrice",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.maxMatchPrice, digit: 2 });
      },
    },
    {
      key: "minMatchPrice",
      name: t("pages.default.offerOperations.table.minMatchPrice"),
      selector: "minMatchPrice",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.minMatchPrice, digit: 2 });
      },
    },
    {
      key: "lastMatchAmount",
      name: t("pages.default.offerOperations.table.lastMatchAmount"),
      selector: "lastMatchAmount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.lastMatchAmount);
      },
    },
    {
      key: "lastMatchPrice",
      name: t("pages.default.offerOperations.table.lastMatchPrice"),
      selector: "lastMatchPrice",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.lastMatchPrice, digit: 2 });
      },
    },
    {
      key: "tradingVolume",
      name: t("pages.default.offerOperations.table.tradingVolume"),
      selector: "tradingVolume",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.tradingVolume);
      },
    },
    {
      key: "weightedAverage",
      name: t("pages.default.offerOperations.table.weightedAverage"),
      selector: "weightedAverage",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.weightedAverage, digit: 2 });
      },
    },
    {
      key: "status",
      name: t("pages.default.offerOperations.table.status"),
      selector: "status",
      sortable: true,
      cell: (row) => {
        return row.status === "ACTIVE" ? (
          <Pill
            type="success"
            label={t("pages.default.offerOperations.active")}
            emphasis
          />
        ) : (
          <Pill
            type="important"
            label={t("pages.default.offerOperations.passive")}
            emphasis
          />
        );
      },
    },
    {
      key: "contractEndTime",
      name: t("pages.default.offerOperations.table.contractEndTime"),
      selector: "contractEndTime",
      sortable: true,
    },
    {
      key: "process",
      name: t("pages.default.offerOperations.table.process"),
      selector: "process",
      sortable: false,
      cell: (row) => {
        return (
          <ToggleSwitch
            id={`${row.id}-process`}
            onChange={(e) => {
              contractProcessChange(e, row);
            }}
            defaultChecked={row.status === "ACTIVE" ? true : false}
          />
        );
      },
    },
    {
      key: "processDetail",
      name: t("pages.default.offerOperations.table.processDetail"),
      selector: "processDetail",
      sortable: false,
      cell: (row) => {
        return (
          <Button
            title={t("ui.default.review")}
            onClick={() => setInspectedContract(row)}
            suffixIcon="search"
            type="secondary"
          />
        );
      },
    },
  ];
  const buyListColumns = [
    {
      name: t("pages.default.offerOperations.table.organizationName"),
      selector: "organizationName",
      sortable: false,
      cell: (row) => {
        return (
          <span className="km__u--text-green-300">{row.organizationName}</span>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.date"),
      selector: "modifiedAt",
      sortable: false,
      width: "200px",
      cell: (row) => {
        return (
          <span className="km__u--text-green-300">
            {moment(row.modifiedAt).format("DD.MM.YYYY HH:mm:ss")}
          </span>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.amount"),
      selector: "remainingAmount",
      sortable: false,
      cell: (row) => {
        return (
          <span className="km__u--text-green-300">
            {convertAmountToFrontend(row.remainingAmount)}
          </span>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.priceCurrency"),
      selector: "price",
      sortable: false,
      cell: (row) => {
        return (
          <span className="km__u--text-green-300">
            {`${convertNumberToFrontend({ num: row.price, digit: 2 })} ₺`}
          </span>
        );
      },
    },
  ];
  const sellListColumns = [
    {
      name: t("pages.default.offerOperations.table.organizationName"),
      selector: "organizationName",
      sortable: false,
      cell: (row) => {
        return (
          <span className="km__u--text-red-300">{row.organizationName}</span>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.date"),
      selector: "modifiedAt",
      sortable: false,
      width: "200px",
      cell: (row) => {
        return (
          <span className="km__u--text-red-300">
            {moment(row.modifiedAt).format("DD.MM.YYYY HH:mm:ss")}
          </span>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.amount"),
      selector: "remainingAmount",
      sortable: false,
      cell: (row) => {
        return (
          <span className="km__u--text-red-300">
            {convertAmountToFrontend(row.remainingAmount)}
          </span>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.priceCurrency"),
      selector: "price",
      sortable: false,
      cell: (row) => {
        return (
          <span className="km__u--text-red-300">
            {`${convertNumberToFrontend({ num: row.price, digit: 2 })} ₺`}
          </span>
        );
      },
    },
  ];
  const offersColumns = [
    {
      name: t("pages.default.offerOperations.table.orderId"),
      selector: "shownId",
      sortable: true,
    },
    {
      name: t("pages.default.offerOperations.table.contractName"),
      selector: "contractName",
      sortable: true,
    },
    {
      name: t("pages.default.offerOperations.table.organizationName"),
      selector: "organizationName",
      sortable: true,
    },
    {
      name: t("pages.default.offerOperations.table.date"),
      selector: "modifiedAt",
      sortable: true,
      cell: (row) => {
        return moment(row.modifiedAt).format("DD.MM.YYYY HH:mm:ss");
      },
    },
    {
      name: t("pages.default.offerOperations.table.type"),
      selector: "type",
      sortable: true,
      cell: (row) => {
        return "standart";
      },
    },
    {
      name: t("pages.default.offerOperations.table.price"),
      selector: "price",
      sortable: true,
      cell: (row) => {
        return `${convertNumberToFrontend({ num: row.price, digit: 2 })} ₺`;
      },
    },
    {
      name: t("pages.default.offerOperations.table.amount"),
      selector: "amount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.amount);
      },
    },
    {
      name: t("pages.default.offerOperations.table.remainingAmount"),
      selector: "remainingAmount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.remainingAmount);
      },
    },
    {
      name: t("pages.default.offerOperations.table.orderType"),
      selector: "orderType",
      sortable: true,
      cell: (row) => {
        return (
          <span
            className={
              row.orderType === "BUY"
                ? "km__u--text-green-300"
                : "km__u--text-red-300"
            }
          >
            {row.orderType === "BUY"
              ? t("pages.default.offerOperations.buy")
              : t("pages.default.offerOperations.sell")}
          </span>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.status"),
      selector: "status",
      sortable: true,
      cell: (row) => {
        return (
          <Pill
            type={offerStatusHandling[row.status].color}
            label={offerStatusHandling[row.status].text}
            emphasis
          />
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.action"),
      selector: "action",
      sortable: true,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            {offerStatusHandling[row.status].showEdit && (
              <Button
                title={t("ui.default.edit")}
                onClick={() => clickOfferEdit(row)}
                suffixIcon="edit"
                type="secondary"
              />
            )}
            {offerStatusHandling[row.status].showDelete && (
              <Button
                title={t("ui.default.delete")}
                suffixIcon="x"
                type="destructive"
                onClick={() => deleteOffer(row)}
              />
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps

    getCurrentSession();

    setInterval(function () {
      API_GET("system-date-time/full").then((res) => {
        const time = res.data;
        setIntervalState(time);
      });
    }, 1000);

    return () => {
      clearInterval(timer1);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getCurrentSession();
      if (selectedContract) {
        API_GET(`system-parameter/contract/${selectedContract.id}`).then(
          (res) => {
            setSelectedContractStatus(res.data.status);
          }
        );
        dispatch(
          getContractDepthRequested({ contractId: selectedContract.id })
        );
        dispatch(getActiveOffersRequested({ contractId: selectedContract.id }));
      }
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedContract]);

  useEffect(() => {
    if (selectedOrganization) {
      API_GET(
        `exchange-order/guarantee/currentBalance/${selectedOrganization.organizationId}`
      ).then((res) => {
        setOrganizationBuyLimit(res.data);
      });
    }
    const interval = setInterval(() => {
      if (
        selectedOrganization &&
        Object.keys(selectedOrganization).length !== 0
      ) {
        API_GET(
          `exchange-order/guarantee/currentBalance/${selectedOrganization.organizationId}`
        ).then((res) => {
          setOrganizationBuyLimit(res.data);
        });
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [selectedOrganization]);

  useEffect(() => {
    if (selectedContract) {
      const foundContract = currentContracts.find(
        (contract) => contract.id === selectedContract.id
      );
      if (
        foundContract?.minPrice !== selectedContract?.minPrice ||
        foundContract?.maxPrice !== selectedContract?.maxPrice
      ) {
        selectedContract.minPrice = foundContract?.minPrice;
        selectedContract.maxPrice = foundContract?.maxPrice;
      }
    }
  }, [currentContracts]);

  const getCurrentSession = () => {
    dispatch(getCurrentSessionsRequested());
  };
  const removeCurrentSession = () => {
    dispatch(removeCurrentContracts());
  };

  useEffect(
    () => () => {
      removeCurrentSession();
    },
    []
  );

  const seanceIsActive = useMemo(() => {
    if (!Array.isArray(currentContracts) || currentContracts.length < 0) {
      return false;
    }

    const now = moment(intervalState);
    const end = moment(currentContracts?.[0]?.contractEndDate);
    const duration = moment.duration(now.diff(end));
    const days = duration.asMilliseconds();

    if (days > 0) {
      return false;
    }

    const findedActiveRow = currentContracts.find(
      (item) => item?.status === "ACTIVE"
    );

    return findedActiveRow ? true : false;
  }, [currentContracts, intervalState]);

  const getTableResultJsx = () => {
    if (loading && currentContracts.length === 0) {
      return <Loading />;
    }

    const rule1 = currentContracts.length === 0;
    let rule2 = false;

    if (currentContracts.length > 0) {
      const now = moment(intervalState);
      const end = moment(currentContracts?.[0]?.contractEndDate);
      const duration = moment.duration(now.diff(end));
      const days = duration.asMilliseconds();
      if (days > 0) {
        rule2 = true;
      }
    }

    if (!loading && (rule1 || rule2)) {
      return (
        <EmptyState
          icon="file-text"
          text={t("pages.default.offerOperations.contractNotFound")}
        />
      );
    }

    return null;
  };

  const contractSelection = (row) => {
    dispatch(contractSelect(row));
    setSelectedContractStatus(row.status);
    dispatch(getContractDepthRequested({ contractId: row.id }));
    dispatch(getActiveOffersRequested({ contractId: row.id }));
  };

  const contractRowSelected = (row) => {
    if (selectedContract) return row.id === selectedContract.id;
    else return false;
  };

  const contractProcessChange = (e, row) => {
    setModalContractProcess(!modalContractProcess);
    // tabledan açılınca
    if (row) {
      setActiveContractProcess(row);
    } else {
      // dışarıya tıklanıp kapanınca contractProcessChangeDismiss triggerlanmalı.
      contractProcessChangeDismiss();
    }
  };

  const contractProcessChangeDismiss = () => {
    let processToggle = document.getElementById(
      activeContractProcess.id + "-process"
    );
    processToggle.checked = !processToggle.checked;
    setModalContractProcess(!modalContractProcess);
    setActiveContractProcess("");
  };

  const contractProcessChangeApproveToggle = () => {
    if (!contractProcessChangeDescription) {
      setNotification("error", "Lütfen açıklama giriniz!");
      return;
    }
    if (contractProcessChangeDescription.length < 10) {
      setNotification(
        "error",
        "Lütfen açıklamanızı en az 10 karakter giriniz!"
      );
      return;
    }
    setContractProcessChangeApproveModal(true);
  };

  const contractProcessChangeApprove = async () => {
    try {
      setContractProcessChangeLoading(true);
      let res = await API_PUT(
        `system-parameter/contract/${activeContractProcess.id}`,
        {
          type: activeContractProcess.type,
          status:
            activeContractProcess.status === "ACTIVE" ? "PASSIVE" : "ACTIVE",
          description: contractProcessChangeDescription,
        }
      );
      if (res.status === 200) {
        await getCurrentSession();
        setContractProcessChangeApproveModal(false);
        setContractProcessChangeLoading(false);
        setModalContractProcess(!modalContractProcess);
        setContractProcessChangeDescription("");
        setActiveContractProcess("");
        setNotification(
          "success",
          "Kontrat durum değişikliği başarıyla gerçekleştirildi"
        );
      }
    } catch (error) {
      setContractProcessChangeLoading(false);
      setContractProcessChangeApproveModal(false);
      setNotification("error", "Something went wrong!");
    }
  };

  const clickOfferEdit = (row) => {
    setEditedOffer(row);
    setEditedOfferClone(row);
    API_GET(
      `exchange-order/guarantee/currentBalance/${row.organizationId}`
    ).then((res) => {
      setEditedOrganizationBuyLimit(res.data);
    });
    if (row.orderType === "BUY") {
      setModalEditBuyOffer(true);
    } else {
      setModalEditSellOffer(true);
    }
  };

  const deleteOffer = (row) => {
    setDeletedOffer(row);
    if (row.orderType === "BUY") {
      setDeletedBuyOffer(true);
    } else {
      setDeletedSellOffer(true);
    }
  };

  const deleteOfferRequest = async () => {
    try {
      setDeletedOfferLoading(true);
      let resOffers = await API_GET(`exchange-order/search`, {
        orderGroupId: deletedOffer.orderGroupId,
      });
      let offers = resOffers.data.items;
      for (let offer of offers) {
        await API_DELETE(`exchange-order/${offer.id}`);
      }
      setNotification(
        "success",
        t("pages.default.offerOperations.success.remove")
      );
      dispatch(getContractDepthRequested({ contractId: selectedContract.id }));
      dispatch(getActiveOffersRequested({ contractId: selectedContract.id }));
      setDeletedOfferLoading(false);
      setDeletedBuyOffer(false);
      setDeletedSellOffer(false);
    } catch (err) {
      setNotification("error", err.response.data.message);
      setDeletedOfferLoading(false);
    }
  };

  const editOfferChange = (e) => {
    setEditedOffer({
      ...editedOffer,
      [e.target.name]: e.target.value,
    });
  };
  const validateEditBuyOfferRequest = () => {
    if (!editedOffer.remainingAmount) {
      setNotification(
        "error",
        t("pages.default.offerOperations.errors.amount")
      );
      return false;
    }
    if (!editedOffer.price) {
      setNotification("error", t("pages.default.offerOperations.errors.price"));
      return false;
    }
    return true;
  };
  const editBuyOfferRequest = async () => {
    if (!validateEditBuyOfferRequest()) {
      return;
    }
    setEditBuyOfferLoading(true);
    try {
      let updatedOffer = {
        deleteRequests: [],
        updateRequests: [],
        createRequests: [],
        passiveRequests: [],
        activeRequests: [],
      };
      // status check
      if (editedOfferClone.status !== editedOffer.status) {
        if (editedOffer.status === "OPEN") {
          updatedOffer.activeRequests.push({ orderId: editedOffer.id });
        } else {
          updatedOffer.passiveRequests.push({ orderId: editedOffer.id });
        }
      }
      if (
        editedOfferClone.remainingAmount !== editedOffer.remainingAmount ||
        editedOfferClone.price !== editedOffer.price ||
        editedOfferClone.status !== editedOffer.status
      ) {
        updatedOffer.updateRequests = [
          {
            price: editedOffer.price,
            amount: editedOffer.remainingAmount,
            prevAmount: editedOfferClone.remainingAmount,
            orderId: editedOffer.id,
            status: editedOffer.status,
          },
        ];
      }
      await API_POST("exchange-order/multi", updatedOffer);
      dispatch(getActiveOffersRequested({ contractId: selectedContract.id }));
      setNotification(
        "success",
        t("pages.default.offerOperations.success.buyOfferUpdate")
      );
      setModalEditBuyOffer(false);
      setEditBuyOfferLoading(false);
      setEditBuyOfferConfirmation(false);
      setEditedOffer();
      setEditedOfferClone();
    } catch (err) {
      setEditBuyOfferLoading(false);
      setNotification("error", err.response.data.message);
    }
  };

  return (
    <>
      <h5 className="km__u--text-has-emphasis km__p--offer-operations-header-container">
        {t("pages.default.offerOperations.title")}
        <div className="km__p--offer-operations-switch-container">
          <ToggleSwitch
            label={t("pages.default.offerOperations.homepage")}
            checked={true}
            onClick={() => history.push("/")}
            readOnly
            id="home-toggle"
          />
        </div>
      </h5>

      <div className="km__p--card">
        {seanceIsActive && (
          <div className="km__p--offer-operations-contracts">
            <p className="km__u--text_title">
              {t("pages.default.offerOperations.contracts")}
            </p>
            {/* Kontratlar */}
            <DataTableDraggable
              cookieName="columns-ad"
              selectableRow
              rowKey="id"
              rowSelection={(row) => contractSelection(row)}
              isRowSelected={(row) => contractRowSelected(row)}
              columns={contractsColumns}
              data={currentContracts}
            />
          </div>
        )}
        {getTableResultJsx()}
      </div>
      {seanceIsActive && selectedContract && (
        <>
          {/* Açık Emirler */}
          <div className="km__p--offer-operations-contract-depth">
            <p className="km__u--text_title">
              <span
                className="km__p--offer-operations-contract-depth-expand"
                onClick={() => setContractDepthModal(true)}
              >
                <Icon name="maximize" size="16" />
              </span>{" "}
              {t("pages.default.offerOperations.contractDepth")} -{" "}
              {selectedContract.contractName}
            </p>
            <div>
              <div className="km__p--offer-operations-buy-list">
                <div className="km__p--offer-operations-buy-list-header">
                  <span className="km__u--text_title km__u--text-green-300">
                    {t("pages.default.offerOperations.buy")}
                  </span>
                </div>
                <DataTableBasic
                  rowKey="id"
                  columns={buyListColumns}
                  data={contractDepthBuyListSmall}
                />
              </div>
              <div className="km__p--offer-operations-sell-list">
                <div className="km__p--offer-operations-sell-list-header">
                  <span className="km__u--text_title km__u--text-red-300">
                    {t("pages.default.offerOperations.sell")}
                  </span>
                </div>
                <DataTableBasic
                  rowKey="id"
                  columns={sellListColumns}
                  data={contractDepthSellListSmall}
                />
              </div>
            </div>
          </div>
          {selectedContractStatus === "ACTIVE" && (
            <>
              {/* Alış Satış Emri Verme */}
              <div className="km__p--offer-operations-offer">
                <ComboBox t={t} />
                {selectedOrganization ? (
                  selectedOrganization.organizationId ? (
                    <OfferTab
                      t={t}
                      selectedOrganization={selectedOrganization}
                      isAdmin={true}
                      organizationBuyLimit={organizationBuyLimit}
                    />
                  ) : null
                ) : null}
              </div>
              <div className="km__p--card">
                <div className="km__p--offer-operations-offers">
                  <p className="km__u--text_title">
                    {t("pages.default.offerOperations.offers")}
                  </p>
                  <DataTable
                    rowKey="id"
                    defaultSortedField="id"
                    pagination
                    paginationPerPage={10}
                    columns={offersColumns}
                    data={activeOffers}
                  />
                </div>
              </div>
            </>
          )}
        </>
      )}
      {/* Kontrat Derinliği Modal */}
      {selectedContract && (
        <Modal
          isOpen={contractDepthModal}
          toggle={() => setContractDepthModal(false)}
        >
          <div className="km__p--offer-operations-contract-depth-header">
            <p className="km__u--text_title">
              {t("pages.default.offerOperations.contractDepth")} -{" "}
              {selectedContract.contractName}
            </p>
            <span onClick={() => setContractDepthModal(false)}>
              <Icon name="x" size="16" />
            </span>
          </div>
          <div className="km__p--offer-operations-contract-depth-row">
            <div className="km__p--offer-operations-contract-depth-column">
              <span className="km__u--text_title km__u--text-green-300">
                {t("pages.default.offerOperations.buy")}
              </span>
              <DataTable
                rowKey="id"
                columns={buyListColumns}
                data={contractDepthBuyList}
                pagination
                paginationPerPage={10}
              />
            </div>
            <div className="km__p--offer-operations-contract-depth-column">
              <span className="km__u--text_title km__u--text-red-300">
                {t("pages.default.offerOperations.sell")}
              </span>
              <DataTable
                rowKey="id"
                columns={sellListColumns}
                data={contractDepthSellList}
                pagination
                paginationPerPage={10}
              />
            </div>
          </div>
        </Modal>
      )}
      {/* Kontrat işlem detayı ekleme */}
      {activeContractProcess && (
        <Modal isOpen={modalContractProcess} toggle={contractProcessChange}>
          <div className="km__p-modal-contract-process-change-body">
            <TitleValue
              title={t("pages.default.offerOperations.contractName")}
              value={activeContractProcess.contractName}
            />
            <TitleValue
              title={t("pages.default.offerOperations.processType")}
              value={
                activeContractProcess.status === "ACTIVE"
                  ? t("pages.default.offerOperations.deactivation")
                  : t("pages.default.offerOperations.activation")
              }
            />
            <Textarea
              defaultValue={contractProcessChangeDescription}
              onChange={(e) => {
                setContractProcessChangeDescription(e.target.value);
              }}
              value={contractProcessChangeDescription}
            />
          </div>
          <div className="km__p-modal-contract-process-change-footer">
            <Button
              type="secondary"
              onClick={contractProcessChangeDismiss}
              label={t("ui.default.discard")}
            />
            <Button
              type="primary"
              onClick={contractProcessChangeApproveToggle}
              label={t("ui.default.save")}
            />
          </div>
        </Modal>
      )}
      {/* Kontrat işlem detayları */}
      {inspectedContract && (
        <ModalContractHistory
          isOpen={inspectedContract ? true : false}
          toggle={() => setInspectedContract()}
          contract={inspectedContract}
        />
      )}
      {/* Alış teklifi güncelleme */}
      {editedOffer && selectedContractStatus === "ACTIVE" && (
        <Modal isOpen={modalEditBuyOffer} toggle={setModalEditBuyOffer}>
          <div className="km__p-modal-edit-buy-offer-body">
            <Input
              label={t("pages.default.offerOperations.orderId")}
              type="text"
              value={editedOffer.shownId}
              disabled
            />
            <Input
              label={t("pages.default.offerOperations.orderType")}
              type="text"
              value={t(
                `ui.default.offerTab.${editedOffer.orderType.toLowerCase()}`
              )}
              disabled
            />
            <Input label="İşlem Tipi" type="text" value={"Standart"} disabled />
            <Select
              label={t("pages.default.offerOperations.orderStatus")}
              value={editedOffer.status}
              name="status"
              onChange={editOfferChange}
              options={[
                {
                  name: t("pages.default.offerOperations.active"),
                  value: "OPEN",
                },
                {
                  name: t("pages.default.offerOperations.passive"),
                  value: "DRAFT",
                },
              ]}
            />
            <Input
              label={t("pages.default.offerOperations.amount")}
              type="number"
              name="remainingAmount"
              min={1}
              onChange={editOfferChange}
              value={editedOffer.remainingAmount}
            />
            <PriceInput
              label={t("pages.default.offerOperations.price")}
              type="number"
              name="price"
              min={selectedContract.minPrice}
              max={selectedContract.maxPrice}
              acceptDecimal
              onChange={editOfferChange}
              value={editedOffer.price}
            />
            <Input
              label={t("pages.default.offerOperations.totalPrice")}
              type="text"
              disabled
              value={`${convertNumberToFrontend({
                num: editedOffer.price * editedOffer.remainingAmount,
                digit: 2,
              })} ₺`}
            />
            <LabelValue
              label={t("pages.default.offerOperations.orderLimit")}
              value={`${convertNumberToFrontend({
                num: editedOrganizationBuyLimit
                  ? editedOrganizationBuyLimit
                  : 0,
                digit: 2,
              })} ₺`}
            />
          </div>
          <div className="km__p-modal-edit-buy-offer-footer">
            <Button
              type="secondary"
              onClick={() => setModalEditBuyOffer(!modalEditBuyOffer)}
              label={t("ui.default.discard")}
            />
            <Button
              type="primary"
              onClick={() => setEditBuyOfferConfirmation(true)}
              label={t("pages.default.offerOperations.updateOrder")}
            />
          </div>
        </Modal>
      )}
      {/* Satış teklifi güncelleme */}
      {editedOffer &&
        selectedContractStatus === "ACTIVE" &&
        modalEditSellOffer && (
          <ModalEditSellOffer
            t={t}
            editedOffer={editedOffer}
            selectedContract={selectedContract}
            isOpen={modalEditSellOffer}
            toggle={setModalEditSellOffer}
          />
        )}
      <ModalConfirmation
        toggle={() => setContractProcessChangeApproveModal(false)}
        isOpen={contractProcessChangeApproveModal}
        approve={contractProcessChangeApprove}
        header={t(
          "pages.default.offerOperations.confirmations.contractProcessChange.title"
        )}
        body={t(
          "pages.default.offerOperations.confirmations.contractProcessChange.description"
        )}
        loading={contractProcessChangeLoading}
      />

      {/* Satış teklifi silme */}
      {deletedSellOffer && (
        <ModalConfirmation
          toggle={() => setDeletedSellOffer()}
          isOpen={deletedSellOffer}
          header={t(
            "pages.default.offerOperations.confirmations.deleteSellOffer.title"
          )}
          body={t(
            "pages.default.offerOperations.confirmations.deleteSellOffer.description"
          )}
          approve={deleteOfferRequest}
          loading={deletedOfferLoading}
        />
      )}
      {/* Alış teklifi silme */}
      {deletedBuyOffer && (
        <ModalConfirmation
          toggle={() => setDeletedBuyOffer()}
          isOpen={deletedBuyOffer}
          header={t(
            "pages.default.offerOperations.confirmations.deleteBuyOffer.title"
          )}
          body={t(
            "pages.default.offerOperations.confirmations.deleteBuyOffer.description"
          )}
          approve={deleteOfferRequest}
          loading={deletedOfferLoading}
        />
      )}
      <ModalConfirmation
        toggle={() => setEditBuyOfferConfirmation(false)}
        isOpen={editBuyOfferConfirmation}
        header={t(
          "pages.default.offerOperations.confirmations.updateBuyOffer.title"
        )}
        body={t(
          "pages.default.offerOperations.confirmations.updateBuyOffer.description"
        )}
        approve={editBuyOfferRequest}
        loading={editBuyOfferLoading}
      />
    </>
  );
}
